// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.t-head[data-v-0bb5df7e] {\r\n  background-color: #e7eff7;\n}\r\n", ""]);
// Exports
module.exports = exports;
